import { Route, Switch } from 'react-router-dom';

import { useAuthenticationDataContext } from './AuthenticationDataProvider';
import { Role, useAuthorizationDataContext } from './AuthorizationDataProvider';

// Pages
import BackofficeApplicationProfile from '../pages/BackofficeApplicationProfile/BackofficeApplicationProfile';
import BackofficeUpgradeRequest from '../pages/BackofficeUpgradeRequest/BackofficeUpgradeRequest';
import BackofficeUserProfile from '../pages/BackofficeUserProfile/BackofficeUserProfile';
import BackofficeUsers from '../pages/BackofficeUsers/BackofficeUsers';
import Calendar from '../pages/Calendar/Calendar';
import EditCurrentProfile from '../pages/EditCurrentProfile/EditCurrentProfile';
import ForgotPassword from '../pages/ForgotPassword/ForgotPassword';
import Login from '../pages/Login/Login';
import Media from '../pages/Media/Media';
import MentorsMenteesList from '../pages/MentorsMenteesList/MentorsMenteesList';
import Registration from '../pages/Registration/Registration';
import ResetPassword from '../pages/ResetPassword/ResetPassword';
import ThankYouForRegistration from '../pages/ThankYouForRegistration/ThankYouForRegistration';
import UserProfile from '../pages/UserProfile/UserProfile';
import UserSettings from '../pages/UserSettings/UserSettings';
import AdminProfile from '../pages/AdminProfile/AdminProfile';
import Resources from '../pages/Resources/Resources';
import ResourceDetail from '../pages/ResourceDetail/ResourceDetail';
import BackofficeResourceList from '../pages/BackofficeResourceList/BackofficeResourceList';
import BackofficeRating from '../pages/BackofficeRating/BackofficeRating';
import MyProfile from '../pages/MyProfile/MyProfile';
import BackofficeFeedbackDetails from "../pages/BackofficeFeedbackDetails/BackofficeFeedbackDetails";
import BackofficeFeedbackList from '../pages/BackofficeFeedbackList/BackofficeFeedbackList';
import Statistics from '../pages/Statistics/Statistics';
import BackofficeHelpRequests from '../pages/BackofficeHelpRequests/BackofficeHelpRequests';
import BackofficeSurveys from "../pages/BackofficeSurveys/BackofficeSurveys";
import BackofficeSurveyDetails from "../pages/BackofficeSurveyDetails/BackofficeSurveyDetails";
import BackofficeConferences from '../pages/BackofficeConferences/BackofficeConferences';
import BackofficeLNLMAttendants from "../pages/BackofficeLNLMAttendants/BackofficeLNLMAttendants";
import BackofficeVideoFeedback from '../pages/BackofficeVideoFeedback/BackofficeVideoFeedback';
import BackofficeUpgradeRequestsList from '../pages/BackofficeUpgradeRequestsList/BackofficeUpgradeRequestsList';
import BackofficeApplicantMenteeUpgradeRequest from '../pages/BackofficeApplicantMenteeUpgradeRequest/BackofficeApplicantMenteeUpgradeRequest';

interface RouteConfig {
	component: () => {}
	exact?: boolean
	path: string
	permissions?: string[]
	private?: boolean
}

const privateRoutes: RouteConfig[] = [
	{
		component: AdminProfile,
		exact: true,
		path: '/users/admin-profile',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	}, {
		component: BackofficeApplicationProfile,
		exact: true,
		path: '/users/application/:id',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	}, {
		component: BackofficeConferences,
		exact: true,
		path: '/lnlm-conferences',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	}, {
		component: BackofficeFeedbackDetails,
		exact: true,
		path: '/feedbacks/:id',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	}, {
		component: BackofficeFeedbackList,
		exact: true,
		path: '/feedbacks',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	}, {
		component: BackofficeHelpRequests,
		exact: true,
		path: '/help-requests',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	}, {
		component: BackofficeVideoFeedback,
		exact: true,
		path: '/video-feedback',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	}, {
		component: BackofficeFeedbackDetails,
		exact: true,
		path: '/video-feedback/:id',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	}, {
		component: BackofficeFeedbackDetails,
		exact: true,
		path: '/help-requests/:id',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	}, {
		component: BackofficeUpgradeRequest,
		exact: true,
		path: '/upgrade-request/:id',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
	},{
		component: BackofficeApplicantMenteeUpgradeRequest,
		exact: true,
		path: '/upgrade-request/applicant-mentee/:id',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
	}, {
		component: BackofficeUserProfile,
		exact: true,
		path: '/users/:id',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	}, {
		component: BackofficeUsers,
		exact: true,
		path: '/users',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	}, {
		component: BackofficeRating,
		exact: true,
		path: '/rating/:userId/:userRatedId',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	}, {
		component: BackofficeResourceList,
		exact: true,
		path: '/resource-list',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	},{
		component: BackofficeSurveys,
		exact: true,
		path: '/surveys',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	}, {
		component: BackofficeSurveyDetails,
		exact: true,
		path: '/surveys/:id',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	},{
		component: BackofficeLNLMAttendants,
		exact: true,
		path: '/lnlm-attendants',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	}, {
		component: BackofficeUpgradeRequestsList,
		exact: true,
		path: '/upgrade-request',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	},{
		component: ResourceDetail,
		exact: true,
		path: '/resource-list/:id',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	},{
		component: Calendar,
		exact: true,
		path: '/calendar',
		permissions: ['ViewUsers'],
		private: true
	}, {
		component: MyProfile,
		exact: true,
		path: '/my-profile',
		permissions: ['ViewUsers'],
		private: true,
	}, {
		component: EditCurrentProfile,
		exact: true,
		path: '/edit-my-profile',
		permissions: ['ViewUsers'],
		private: true,
	}, {
		component: MentorsMenteesList,
		exact: true,
		path: '/members-list',
		permissions: ['ViewUsers'],
		private: true,
	}, {
		component: Media,
		path: '/media',
		permissions: [],
		private: true,
	},
	{
		component: Resources,
		exact: true,
		path: '/resources',
		permissions: ['ViewUsers'],
		private: true,
	},
	{
		component: ResourceDetail,
		exact: true,
		path: '/resources/:id',
		permissions: ['ViewUsers'],
		private: true,
	},
	{
		component: Statistics,
		exact: true,
		path: '/statistics',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
		private: true,
	}, 
	{
		component: UserProfile,
		exact: true,
		path: '/members-list/:id',
		permissions: ['ViewUsers'],
		private: true,
	},
	{
		component: UserSettings,
		exact: true,
		path: '/user-settings',
		permissions: ['ViewUsers'],
		private: true,
	}
];

const publicRoutes: RouteConfig[] = [
	{
		component: Registration,
		exact: true,
		path: '/registration',
		permissions: [],
		private: false,
	}, {
		component: ThankYouForRegistration,
		path: '/registration/thank-you/:applicationType',
		permissions: [],
		private: false,
	}, {
		component: ForgotPassword,
		path: '/forgot-password',
		permissions: [],
		private: false,
	}, {
		component: ResetPassword,
		path: '/reset-password',
		permissions: [],
		private: false,
	}, {
		component: ResetPassword,
		path: '/set-password',
		permissions: [],
		private: false,
	},
];

const getDefaultRoute = (role: Role) => {
	if (role === 'Admin') {
		return BackofficeUsers;
	} else {
		return MentorsMenteesList;
	}
}

const PrivateRoute = ({ component, permissions, ...options }: any) => {
	const { isAuthenticated } = useAuthenticationDataContext();
	const { isAuthorized, role } = useAuthorizationDataContext();

	let finalComponent;

	if (isAuthenticated()) {
		finalComponent = isAuthorized(permissions) ? component : getDefaultRoute(role);
	} else {
		finalComponent = Login;
	}

	return <Route {...options} component={finalComponent} />;
};

const PublicRoute = ({ component, permissions, ...options }: any) => {
	const { isAuthenticated } = useAuthenticationDataContext();
	const { role } = useAuthorizationDataContext();
	const finalComponent = !isAuthenticated() ? component : getDefaultRoute(role);

	return <Route {...options} component={finalComponent} />;
};

const ErrorRoute = ({ ...options }: any) => {
	const { isAuthenticated } = useAuthenticationDataContext();
	const { role } = useAuthorizationDataContext();
	const finalComponent = !isAuthenticated() ? Login : getDefaultRoute(role);

	return <Route {...options} component={finalComponent} />;
};

const Router = () => (
	<Switch>
		{publicRoutes.map((routeConfig: RouteConfig, i: number) => <PublicRoute key={`publicRoute${i}`} {...routeConfig} />)}
		{privateRoutes.map((routeConfig: RouteConfig, i: number) => <PrivateRoute key={`privateRoute${i}`} {...routeConfig} />)}
		<ErrorRoute path="*" />
	</Switch>
);

export default Router;